import axios from 'axios/dist/axios';


const defaultState = {


    medicalDeviceInfoPopupData: null,
    mustShowMedicalDeviceInfoPopup: false,
};


// ======================================================================
// Initial State
// ======================================================================

const state = {
    medicalDeviceInfoPopupData: defaultState.medicalDeviceInfoPopupData,
    mustShowMedicalDeviceInfoPopup: defaultState.mustShowMedicalDeviceInfoPopup,

};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getMedicalDeviceInfoPopupData: state => state.medicalDeviceInfoPopupData,
    getMustShowMedicalDeviceInfoPopup: state => state.mustShowMedicalDeviceInfoPopup,
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    showMedicalDeviceInfoPopup({commit}) {
        console.log("Clicked showMedicalDeviceInfoPopup");
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/showInfo');

            axiosRequest.then((response) => {
                commit('setMedicalDeviceInfoPopupData', response.data);
                commit('setMustShowMedicalDeviceInfoPopup', true);

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    showInfoPopup({ commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowInfoPopup', true);

        });

        return promise;
    },
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setMedicalDeviceInfoPopupData (state, data) {
        state.medicalDeviceInfoPopupData = data;
    },
    setMustShowMedicalDeviceInfoPopup (state, data) {
        state.mustShowMedicalDeviceInfoPopup = data;
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.medicalDeviceInfoPopupData = defaultState.medicalDeviceInfoPopupData;
        state.mustShowMedicalDeviceInfoPopup= defaultState.mustShowMedicalDeviceInfoPopup;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/MedicalDeviceInfoStore.js